

import React, { useState } from 'react';

//bg image
import bgimage from "../Components/Selfimg/bgimage.webp";

///books overView image 
import atomic from './Selfimg/atomic.jpg'
import money from './Selfimg/money.webp'
import mindset from './Selfimg/mindset.jpg'
import greatgood from './Selfimg/greatgood.jpg'
import habits from './Selfimg/7Habits.jpg'


//importing a pdf 

import { Link } from 'react-router-dom';

const SelfImprove = () => {
  const [selectedBook, setSelectedBook] = useState(null);

  const books = [
    { image: atomic, alt: 'Atomic Habits', name: 'Atomic Habits', path:"12FbuZQyGjqNJTYspg_lyAmY6IV5ZQ_x9" },
    { image: money, alt: 'Psychology Of Money', name: 'Psychology Of Money', path: "1eGnMfScpJc8LJsCF5FiDFrhDucG23ymm" },
    { image: mindset, alt: 'Mind Set', name: 'Mind Set', path:"1cwHAym5LITDFdv6Z06S32onmMnSXUFv8" },
    { image: greatgood, alt: 'Great To Good', name: 'Great To Good', path:"1cewBagXSRtplqdtDKo3qg0bdKoCeDaD0" },
    { image: habits, alt: 'The 7 Habits of Highly Effective People', name: 'The 7 Habits of Highly Effective People', path:"1iIooeDYZmJ-28jMyU2UH1MRVst-xgyAQ" },
  ];

  return (
    <div className="w-full h-screen flex flex-col">
      {/* Background Image Section */}
      {!selectedBook && (
        <div style={{ backgroundImage: `url(${bgimage})` }} className="bg-cover bg-top w-full h-[50vh]">
          <div className="bg-black bg-opacity-50 h-full flex justify-center items-center">
            <h1 className="sm:text-5xl md:text-5xl font-bold text-white">SELF-IMPROVEMENT BOOKS</h1>
          </div>
        </div>
      )}

      {/* Books Grid */}
      {!selectedBook && (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 p-5">
          {books.map((book, index) => (
            <div 
              key={index} 
              className="text-center p-3 bg-gray-50 rounded-md shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-gray-200"
            >
              <img 
                src={book.image} 
                alt={book.alt} 
                className="w-full h-72 object-cover rounded-xl"
              />
              <h1 className="text-black font-bold mt-3 text-sm sm:text-base">{book.name}</h1>
          <Link to='/show'
          state={{
            book:book,
          }}>
          <button
                onClick={() => setSelectedBook(book.path)}
                className="mt-3 px-5 py-2 bg-[#66FCF1] text-[#1F2833] rounded-lg font-bold hover:bg-[#45E0D3] transition duration-300 shadow-md"
              >
                Read Book
              </button>
          </Link>
            </div>
          ))}
        </div>
      )}

      {/* Fullscreen PDF Viewer
      {selectedBook && (
        <div className="fixed inset-0 bg-white flex flex-col items-center justify-center">
          <button
            onClick={() => setSelectedBook(null)}
            className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-lg font-bold hover:bg-red-600"
          >
            Close
          </button>
          <embed
            src={`${selectedBook}#toolbar=0&navpanes=0&scrollbar=1`}
            type="application/pdf"
            className="w-full h-full"
          />
        </div>
      )} */}
    </div>
  );
};

export default  SelfImprove;
